let html = `
<svg width="405" height="231" viewBox="0 0 405 231" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.0439453" y="0.88324" width="128.983" height="176.589" rx="8" fill="currentColor"/>
<rect x="0.0439453" y="188.183" width="101.693" height="15.7554" rx="7.87772" fill="currentColor"/>
<rect x="0.0439453" y="214.65" width="38.7578" height="15.7554" rx="7.87772" fill="currentColor" fill-opacity="0.4"/>
<rect x="12.5444" y="148.134" width="56.3374" height="13.6923" rx="6.84617" fill="#D9D9D9"/>
<rect x="12.5444" y="21.3535" width="34.5581" height="13.6923" rx="6.84617" fill="#D9D9D9"/>
<rect x="137.822" y="0.88324" width="128.983" height="176.589" rx="8" fill="currentColor"/>
<rect x="137.822" y="188.183" width="60.165" height="15.7554" rx="7.87772" fill="currentColor"/>
<rect x="137.822" y="214.65" width="38.7578" height="15.7554" rx="7.87772" fill="currentColor" fill-opacity="0.4"/>
<rect x="150.323" y="148.134" width="58.8701" height="13.6923" rx="6.84617" fill="#D9D9D9"/>
<rect x="150.323" y="21.3535" width="26.2573" height="13.6923" rx="6.84617" fill="#D9D9D9"/>
<rect x="224.242" y="148.134" width="26.2573" height="13.6923" rx="6.84617" fill="#D9D9D9"/>
<rect x="275.601" y="0.88324" width="128.983" height="176.589" rx="8" fill="currentColor"/>
<rect x="275.601" y="188.183" width="109.955" height="15.7554" rx="7.87772" fill="currentColor"/>
<rect x="275.601" y="214.65" width="38.7578" height="15.7554" rx="7.87772" fill="currentColor" fill-opacity="0.4"/>
<rect x="288.101" y="148.134" width="75.0439" height="13.6923" rx="6.84617" fill="#D9D9D9"/>
<rect x="288.101" y="21.3535" width="46.7866" height="13.6923" rx="6.84617" fill="#D9D9D9"/>
</svg>
`
export default html